import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import Label from "../../../components/Label";
import { fontSize, fontWeight } from "styled-system";

const DropdownWrapper = styled.div`
  position: relative;
  width: 170px;
  height: 40px;
  font-family: sans-serif;

  margin-top: -20px;
`;

const DropdownHeader = styled.div`
  && {
    border-radius: 8px;
    cursor: pointer;
    background: white;
    font-size: 14px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }
`;

const DropdownList = styled.div`
  position: absolute;
  top: 180%;
  left: -25%;
  width: 250px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
  max-height: 300px;
  overflow-y: auto;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
`;

const SearchInput = styled.input`
  width: 95%;
  padding: 8px 10px;
  margin: 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
`;

const Option = styled.div`
  padding: 12px;
  display: flex;
  align-items: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border-bottom: 1px solid rgba(239, 240, 246, 1);
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover {
    background: #f3f3f3;
  }

  input {
    margin-right: 10px;
    accent-color: #d0004b;
  }
`;

const DoneButton = styled.div`
  padding: 12px;
  color: #d0004b;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  border-top: 1px solid #eee;
`;

const FooterButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  border-top: 1px solid #eee;
  background: white;
  position: sticky;
  bottom: 0;
`;

const FooterButton = styled.button`
  padding: 8px 16px;
  font-weight: bold;
  font-size: 13px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const ClearButton = styled(FooterButton)`
  background: transparent;
  color: #d0004b;
  font-size:14px;
  text-decoration: underline;
`;

const ApplyButton = styled(FooterButton)`
  background: #d0004b;
  border-radius:25px;
  width:85px;
  font-size:14px;
  color: white;
`;

const DonationCheckbox = ({
  options = [],
  label = "Select Campaign",
  onChange,
  fetchDonationStats,
  selectedDonations
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [search, setSearch] = useState("");
  const ref = useRef();

  useEffect(() => {
    const listener = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", listener);
    return () => document.removeEventListener("mousedown", listener);
  }, []);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
    setSearch("");
  };

  const handleOptionChange = (value) => {
    const exists = selectedValues.includes(value);
    let updated = [];

    if (exists) {
      updated = selectedValues.filter((v) => v !== value);
    } else {
      if (selectedValues.length >= 5) return;
      updated = [...selectedValues, value];
    }

    setSelectedValues(updated);
    onChange?.(updated);
  };

  const handleDone = (isClearAll = false) => {
    setIsOpen(false);
    fetchDonationStats(isClearAll)
  };

  const filteredOptions = options
    .filter((opt) => opt.label.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      const aSelected = selectedValues.includes(a.value);
      const bSelected = selectedValues.includes(b.value);
      return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
    });

  return (
    <DropdownWrapper ref={ref}>
      <Label style={{ fontSize: "14px", color: "#7e7e7e", fontWeight: "500" }}>
        {label} <span style={{ color: "red" }}>*</span>
      </Label>
      <DropdownHeader className="input-box" onClick={toggleDropdown}>
        <div style={{ color: "#7e7e7e" }}>
          {selectedValues.length
            ? `${selectedValues.length}/${Math.min(options?.length,5)} selected`
            : label}
        </div>
        <span>▾</span>
      </DropdownHeader>

      {isOpen && (
        <DropdownList>
          {/* <SearchInput
            type="text"
            placeholder="Search mosques..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          /> */}

          {filteredOptions.map((opt) => {
            const isChecked = selectedValues.includes(opt.value);
            const isDisabled = !isChecked && selectedValues.length >= 5;

            return (
              <Option
                key={opt.value}
                checked={isChecked}
                disabled={isDisabled}
                onClick={() => !isDisabled && handleOptionChange(opt.value)}
              >
                <input
                  type="checkbox"
                  checked={isChecked}
                  disabled={isDisabled}
                  onChange={() => {}}
                />
                {opt.label}
              </Option>
            );
          })}

          <FooterButtons>
            <ClearButton
              onClick={() => {
                setSelectedValues([]);
                onChange?.([]);
                handleDone(true);
              }}
            >
              Clear All
            </ClearButton>

            <ApplyButton onClick={()=>handleDone(false)}>Apply</ApplyButton>
          </FooterButtons>
        </DropdownList>
      )}
    </DropdownWrapper>
  );
};

export default DonationCheckbox;
